<template> 
    <div>
        <el-dialog title="作业完成信息" width="95%" :visible.sync="viewCompleteworkVisible" :before-close="viewCompleteworkClose" 
        v-dialogDrag :close-on-click-modal="false" class="finishIssueGood_dialog" v-if="viewCompleteworkVisible">
        <!-- 未完成状态下显示 -->
            <el-form class="demo-form-inline" :inline="true" ref="finishIssueGoodsForm" :model="finishIssueGoodsList" :rules="finishIssueGoodsFormRules"
            size="mini" label-width="100px" v-if="completeworkRow.rowStatus !== '完成' && loading ">
                <el-form-item label="下发人" prop="createMan" > 
                    <el-input disabled v-model="finishIssueGoodsList.createMan" suffix-icon="xxxx" ></el-input>
                </el-form-item>
                <el-form-item label="确认人" prop="signMan"> 
                    <el-input disabled v-model="finishIssueGoodsList.signMan" suffix-icon="xxxx" ></el-input>
                </el-form-item>
                <el-form-item label="司机" prop="driver" v-if="completeworkRow.taskType !== '移库作业' "> 
                    <el-input  disabled v-model="finishIssueGoodsList.driver" suffix-icon="xxxx" ></el-input>
                </el-form-item>
                <el-form-item label="车牌" prop="truckNo" v-if="completeworkRow.taskType !== '移库作业' "> 
                    <el-input disabled v-model="finishIssueGoodsList.truckNo" suffix-icon="xxxx" ></el-input>
                </el-form-item>
                <el-form-item label="实际理货员" prop="storekeeper"> 
                    <el-select class="width_100"  v-model="finishIssueGoodsList.storekeeper" placeholder="请选择理货员" >
                        <el-option v-for="item in storekeeperList"  :key="item.name" :label="item.name " :value="item.name">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item v-if="completeworkRow.taskType !== '移库作业' " :label="completeworkRow.taskType === '入库作业' ? '入库日期' : (completeworkRow.taskType === '出库作业'? '出库日期': '移库日期')" prop="completeDate">
                     <el-date-picker v-model="finishIssueGoodsList.completeDate" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"
                     style="width: 193px;" :picker-options="pickerOptions" > </el-date-picker>
                </el-form-item>
                <el-form-item label="备注" prop="opNote"> 
                    <el-input placeholder="" v-model="finishIssueGoodsList.opNote" style="width:495px"  suffix-icon="xxxx"></el-input>
                </el-form-item>
                <el-row>
                    <el-col>
                        <el-form-item label="">
                            <span style="font-size: 14px;color: #606266;">总件数：{{ finishIssueGoodsList.qty1 }}  &nbsp; &nbsp; 总净重(KG): {{ finishIssueGoodsList.netWeight }} </span> 
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        <!-- 完成状态下显示 -->
            <el-descriptions  :column="7" v-if="completeworkRow.rowStatus === '完成'&& loading  ">
                <el-descriptions-item label="下发人">{{ completeworkRow.createMan }}</el-descriptions-item>
                <el-descriptions-item label="确认人">{{ completeworkRow.signMan }}</el-descriptions-item>
                <el-descriptions-item label="司机" v-if="completeworkRow.taskType !== '移库作业' " >{{ completeworkRow.driver }}</el-descriptions-item>
                <el-descriptions-item label="车牌" v-if="completeworkRow.taskType !== '移库作业' " >{{ completeworkRow.truckNo }}</el-descriptions-item>
                <el-descriptions-item label="理货员">{{ completeworkRow.storekeeper }}</el-descriptions-item>
                <el-descriptions-item label="备注">{{ completeworkRow.note }}</el-descriptions-item>
            </el-descriptions>
            <!-- 未完成状态下显示 -->
            <!-- 显示货物信息 -->
            <vxe-table border size="mini" ref="finishIssueGoodsTable" :data="finishIssueGoodsList.childList" :row-config="{keyField: 'rowKey'}" header-align="center"
            style="max-height: 400px; overflow-y: auto; " v-if="completeworkRow.rowStatus !== '完成' && loading">
                <vxe-column field="goodsName" title="货物信息"  fixed="left" min-width="180">
                    <template #default="{ row, $rowIndex }" >
                        <span v-if="row.lotNo">{{ row.goodsName }} - {{ row.lotNo }} - {{ row.lotKgs }}</span>
                        <span v-if="row.lotNo" style="display: flex;flex-direction: column;">
                            <span>订单号:{{ row.lotOrderNo }}  &nbsp; 物料号:{{ row.lotMaterialNo }}</span>
                        </span>
                        <span v-else>
                            {{ row.goodsName }} - {{ row.spec }}
                        </span>
                    </template>
                </vxe-column>
                <vxe-column field="place" title="实际库区库位" width="260">
                    <template #default="{ row,$rowIndex }"> 
                        <span class="IssueGoodsExitRow" v-if="completeworkRow.taskType === '入库作业'">
                            <span class="IssueGoodsExitRow_flex" >
                                <el-select @change="(value) =>placeRowEnter(value, row, $rowIndex)" v-model="row.place" placeholder="请选择库区" size="mini" filterable>
                                    <el-option v-for="item in placeList"  :key="item.name" :label="item.name " :value="item.name + '-' + item.id">
                                    </el-option>
                                </el-select>
                                <el-select filterable size="mini"  @change="(value) => locationRowEnter(value, row, $rowIndex)" @focus="locationRowFocus( row, $rowIndex)"
                                    v-model="row.location" placeholder="请选择库位" >
                                    <el-option v-for="item in locationList"  :key="item.locationName" :label="item.locationName " :value="item.locationName">
                                    </el-option>
                                </el-select>
                            </span>
                            <span class="IssueGoodsTipText">计划库区库位：{{ finishIssueGoodsList.childList[$rowIndex].planPlace }}- {{finishIssueGoodsList.childList[$rowIndex].planLocation}}</span>
                        </span>
                        <span v-else>{{ row.place }} - {{ row.location }}</span>
                    </template>
                </vxe-column>
                <vxe-column field="itemNo" title="项号" width="120" v-if="completeworkRow.taskType === '入库作业'" >
                    <template  #default="{ row ,$rowIndex }">
                        <span class="IssueGoodsExitRow">
                            <el-input size="mini" v-model="row.itemNo" placeholder="请输入项号" @input="(value) => batchItemNo( row, value, $rowIndex)"  ></el-input>
                            <span style="width: 20px;height:22px"> </span>
                        </span>
                    </template>
                </vxe-column>
                <vxe-column field="qty1" title="实际件数1">
                    <template  #default="{ row ,$rowIndex }">
                        <span class="IssueGoodsExitRow" v-if="completeworkRow.taskType === '入库作业'">
                            <el-input size="mini" v-model="row.qty1" placeholder="请输入件数1"  @blur="finishIssueGoodsRowQty1Blur(row,$rowIndex)"
                            onkeyup="value=value.match(/^[1-9]\d*\.?\d{0,4}|0\.\d{1,4}/) || ''"></el-input>
                            <span class="IssueGoodsTipText">计划件数1：{{finishIssueGoodsList.childList[$rowIndex].planQty1}}</span>
                        </span>
                        <span v-else>{{ row.qty1 }}</span>
                    </template>
                </vxe-column>
                <vxe-column field="qty2" title="实际件数2" >
                    <template #default="{ row ,$rowIndex }">
                        <span class="IssueGoodsExitRow"  v-if="completeworkRow.taskType=== '入库作业'">
                            <el-input size="mini" v-if="!!finishIssueGoodsListVisit.childList[$rowIndex]?.qty2" v-model="row.qty2" placeholder="请输入件数2"
                            onkeyup="value=value.match(/^[1-9]\d*\.?\d{0,4}|0\.\d{1,4}/) || ''" ></el-input>
                            <span v-else>{{ row.qty2 }}</span>
                            <span class="IssueGoodsTipText">计划件数2：{{finishIssueGoodsList.childList[$rowIndex].planQty2}}</span>
                        </span>
                        <span v-else>{{ row.qty2 }}</span>
                    </template>
                </vxe-column>
                <vxe-column field="netWeight" title="实际净重（KG）" >
                    <template #default="{ row,$rowIndex }">
                        <span class="IssueGoodsExitRow" v-if="completeworkRow.taskType === '入库作业'">
                            <el-input size="mini" v-if="!!finishIssueGoodsListVisit.childList[$rowIndex]?.netWeight" v-model="row.netWeight" placeholder="请输入净重"
                            onkeyup="value=value.match(/^[1-9]\d*\.?\d{0,4}|0\.\d{1,4}/) || ''" ></el-input>
                            <span v-else>{{ row.netWeight }}</span>
                            <span class="IssueGoodsTipText">计划净重：{{finishIssueGoodsList.childList[$rowIndex].planNetWeight}}</span>
                        </span>
                        <span v-else>{{ row.netWeight }}</span>
                    </template>
                </vxe-column>
                    <vxe-column field="decAmount" title="实际申报金额" >
                    <template #default="{ row,$rowIndex }">
                        <span class="IssueGoodsExitRow" v-if="completeworkRow.taskType === '入库作业'">
                            <el-input size="mini" v-if="!!finishIssueGoodsListVisit.childList[$rowIndex]?.decAmount" v-model="row.decAmount" placeholder="请输入申报金额"
                            onkeyup="value=value.match(/^[1-9]\d*\.?\d{0,4}|0\.\d{1,4}/) || ''" ></el-input>
                            <span v-else>{{ row.decAmount }}</span>
                            <span class="IssueGoodsTipText">计划申报金额：{{finishIssueGoodsList.childList[$rowIndex].planDecAmount}}</span>
                        </span>
                        <span v-else>{{ row.decAmount }}</span>
                    </template>
                </vxe-column>
                <vxe-column field="decNum" title="申报数量" >
                    <template #default="{ row,$rowIndex }">
                            <span>{{ row.decNum }}</span>
                    </template>
                </vxe-column>
                <vxe-column field="firstNum" title="法定第一数量" >
                    <template #default="{ row,$rowIndex }">
                            <span >{{ row.firstNum }}</span>
                    </template>
                </vxe-column>
                <vxe-column field="secondNum" title="法定第二数量" >
                    <template #default="{ row,$rowIndex }">
                            <span >{{ row.secondNum }}</span>
                    </template>
                </vxe-column>
                <vxe-column field="" title="操作" width="100"  v-if="completeworkRow.taskType=== '入库作业'" >
                    <template #default="{ row,$rowIndex }">
                        <el-button type="text" :disabled="!row.id" size="mini" @click="splitFinishIssueGoods(row,$rowIndex)">拆分</el-button>
                        <el-button type="text" :disabled="!!row.id" size="mini" @click="delIssueGoodsRow(row,$rowIndex)">删除</el-button>
                    </template>
                </vxe-column>
            </vxe-table>
            <!-- 完成状态下显示 -->
            <vxe-table border size="mini" ref="goodsTable" :data="completeworkRow.childList" :row-config="{keyField: 'id'}" header-align="center"
                style="max-height: 400px; overflow-y: auto; " v-if="completeworkRow.rowStatus === '完成'&& loading  ">
                <vxe-column field="goodsName" title="货物信息"  fixed="left" min-width="100">
                    <template #default="{ row, $rowIndex }" >
                        <span v-if="row.lotNo">{{ row.goodsName }} - {{ row.lotNo }} - {{ row.lotKgs }}</span>
                        <span v-if="row.lotNo" style="display: flex;flex-direction: column;">
                            <span>订单号:{{ row.lotOrderNo }}  &nbsp; 物料号:{{ row.lotMaterialNo }}</span>
                        </span>
                        <span v-else>
                            {{ row.goodsName }} - {{ row.spec }}
                        </span>
                    </template>
                </vxe-column>
                <vxe-column field="place" title="库区库位" min-width="100" >
                    <template #default="{ row, $rowIndex }" >
                        {{ row.place }} - {{ row.location }}
                    </template>
                </vxe-column>
                <vxe-column field="itemNo" title="项号" min-width="80"></vxe-column>
                <vxe-column field="qty1" title="件数1" min-width="80"></vxe-column>
                <vxe-column field="qty2" title="件数2" min-width="80"></vxe-column>
                <vxe-column field="netWeight" title="净重（KG）" min-width="80"></vxe-column>
                <vxe-column field="decAmount" title="申报金额" min-width="80"></vxe-column>
                <vxe-column field="decNum" title="申报数量" min-width="80"></vxe-column>
                <vxe-column field="firstNum" title="法定第一数量" min-width="80"></vxe-column>
                <vxe-column field="secondNum" title="法定第二数量" min-width="80"></vxe-column>
            </vxe-table>
            <!-- 工作量表格 未完成状态 -->
            <el-button size="mini" :disabled="completeworkRow.rowStatus === '完成' " @click="addSignWorkRowEvent()" style="margin: 5px 0px;">新增行</el-button>
            <vxe-table border size="mini" ref="signWorkTable" :data="signWorkTable" style="max-height: 300px; overflow-y: auto; "
            v-if="completeworkRow.rowStatus !== '完成' && loading ">
                <vxe-column field="driver" title="叉车司机" >
                    <template #default="{ row, $rowIndex }">
                        <el-select class="width_100" size="mini" v-model="row.driver" placeholder="请选择叉车司机"
                         @change="(value) => changeDriver(value, row, $rowIndex)">
                            <el-option v-for="item in signWorkDriverList"  :key="item.value" :label="item.value " :value="item.value">
                            </el-option>
                        </el-select>
                    </template>
                </vxe-column>
                <vxe-column field="tons" title="工作量" >
                    <template #default="{ row, $rowIndex }">
                        <!--  -->
                         <!-- oninput="value=value.replace(/[^\d\.]/g,'').replace(/^\./g,'').replace(/\.{2,}/g,'.').replace('.','$#$').replace(/\./g,'').replace('$#$','.')" -->
                        <el-input size="mini" v-model="row.tons"  placeholder="请输入工作量" oninput="let v=this.value.replace(/[^\d.]/g,'').replace(/^\./,'');let d=v.indexOf('.');this.value=d>-1?v.slice(0,d+7):v"
                        @input="(value) => signWorkTableRowTonsInput(value,row,$rowIndex)"></el-input>
                    </template>
                </vxe-column>
                    <vxe-column field="workUnit" title="作业单位" >
                    <template #default="{ row, $rowIndex }">
                        <el-select class="width_100" size="mini" v-model="row.workUnit" placeholder="请选择作业单位"
                        @change="(value) => changeWorkUnit(value, row, $rowIndex)">
                            <el-option v-for="item in signWorkUnitList"  :key="item.value" :label="item.value " :value="item.value">
                            </el-option>
                        </el-select>
                    </template>
                </vxe-column>
                <vxe-column field="workType" title="作业类型" >
                    <template #default="{ row, $rowIndex }">
                        <el-select class="width_100" size="mini" v-model="row.workType" placeholder="请选择作业类型"
                        @change="(value) => changeWorkType(value, row, $rowIndex)">
                            <el-option v-for="item in signWorkTypeList"  :key="item.value" :label="item.value " :value="item.value">
                            </el-option>
                        </el-select>
                    </template>
                </vxe-column>
                <vxe-column field="goodsName" title="货物名称" >
                    <template #default="{ row, $rowIndex }">
                        <el-select class="width_100" size="mini" v-model="row.goodsName" placeholder="请选择货物名称">
                            <el-option v-for="item in signWorkGoodsNameList"  :key="item.value" :label="item.value " :value="item.value">
                            </el-option>
                        </el-select>
                    </template>
                </vxe-column>
                <vxe-column field="remark" title="备注" >
                    <template #default="{ row }">
                        <el-input size="mini" v-model="row.remark"  placeholder="请输入备注"></el-input>
                    </template>
                </vxe-column>
                    <vxe-column field="" title="操作" width="60" >
                    <template #default="{ row,$rowIndex }">
                        <el-button type="text" size="mini" @click="delSignWork(row,$rowIndex)">删除</el-button>
                    </template>
                </vxe-column>
            </vxe-table>
            <!-- 完成展示 -->
            <vxe-table border size="mini" ref="signWorkTable" :data="signWorkTable" style="max-height: 300px; overflow-y: auto; "
            v-if="completeworkRow.rowStatus === '完成'&& loading ">
                <vxe-column field="driver" title="叉车司机" ></vxe-column>
                <vxe-column field="tons" title="工作量" ></vxe-column>
                <vxe-column field="workUnit" title="作业单位" ></vxe-column>
                <vxe-column field="workType" title="作业类型" ></vxe-column>
                <vxe-column field="goodsName" title="货物名称" ></vxe-column>
                <vxe-column field="remark" title="备注" ></vxe-column>
            </vxe-table>
            <!-- 上传附件 -->
            <div v-if="completeworkRow.taskType !== '移库作业'">
                <div style="display: flex; justify-content: space-around;" > 
                    <div class="finish_upload">
                        <div class="finish_text">上传受理单</div>
                        <div class="finish_IMG">
                            <div v-for="(item,index) in acceptFilesView" :key="index" >
                                <el-image class="IMG" :src="item" :preview-src-list="acceptFilesView" > </el-image>
                            </div>
                        </div>
                        <el-upload  drag
                            :action="issueGoodsIMGupLoadFilesURL" multiple :auto-upload="false" 
                            list-type="picture-card" :file-list="acceptFiles" :headers="headers"
                            :on-change="handleChangeAccept"
                            :on-remove="handleRemoveAccept"
                            :on-preview="handlePreviewAccept"
                            :accept="acceptImageTypes"
                            >
                            <i class="el-icon-plus"></i>
                        </el-upload>
                    </div>
                    <div class="finish_upload">
                        <!-- <div class="finish_text">上传车辆/货物图片</div> -->
                        <div class="finish_text">
                            <span v-if="completeworkRow.taskType !== '出库作业'">上传开箱前图片</span>
                            <span v-else> 上传空箱照片 </span>
                        </div>
                        <div class="finish_IMG">
                            <div v-for="(item,index) in openingBoxBrforeFilesView" :key="index" >
                                <el-image class="IMG" :src="item" :preview-src-list="openingBoxBrforeFilesView" > </el-image>
                            </div>
                        </div>
                        <el-upload drag
                            :action="issueGoodsIMGupLoadFilesURL" multiple :auto-upload="false" 
                            list-type="picture-card" :file-list="openingBoxBrforeFiles"  :headers="headers"
                            :on-change="handleChangeOpeningBoxBrfore"
                            :on-remove="handleRemoveOpeningBoxBrfore"
                            :on-preview="handlePreviewOpeningBoxBrfore"
                            :accept="acceptImageTypes"
                            >
                            <i class="el-icon-plus"></i>
                        </el-upload>
                    </div>
                </div>
                <div style="display: flex; justify-content: space-around;"> 
                    <div class="finish_upload">
                        <div class="finish_text">上传作业中图片</div>
                        <div class="finish_IMG">
                            <div v-for="(item,index) in inHomeWorkFilesView" :key="index" >
                                <el-image class="IMG" :src="item" :preview-src-list="inHomeWorkFilesView" > </el-image>
                            </div>
                        </div>
                        <el-upload drag
                            :action="issueGoodsIMGupLoadFilesURL" multiple :auto-upload="false" 
                            list-type="picture-card" :file-list="inHomeWorkFiles"  :headers="headers"
                            :on-change="handleChangeInHomeWork"
                            :on-remove="handleRemoveInHomeWork"
                            :on-preview="handlePreviewInHomeWork"
                            :accept="acceptImageTypes"
                            >
                            <i class="el-icon-plus"></i>
                        </el-upload>
                    </div>
                    <div class="finish_upload">
                        <div class="finish_text">上传作业结束图片</div>
                        <div class="finish_IMG">
                            <div v-for="(item,index) in endHomeWorkFilesView" :key="index" >
                                <el-image class="IMG" :src="item" :preview-src-list="endHomeWorkFilesView" > </el-image>
                            </div>
                        </div>
                        <el-upload drag
                            :action="issueGoodsIMGupLoadFilesURL" multiple :auto-upload="false" 
                            list-type="picture-card" :file-list="endHomeWorkFiles"  :headers="headers"
                            :on-change="handleChangeEndHomeWork"
                            :on-remove="handleRemoveEndHomeWork"
                            :on-preview="handlePreviewEndHomeWork"
                            :accept="acceptImageTypes"
                            >
                            <i class="el-icon-plus"></i>
                        </el-upload>
                    </div>
                </div>
                <div class="finish_upload">
                    <div class="finish_text">异常</div>
                    <div class="finish_IMG">
                        <div v-for="(item,index) in exceptionFilesView" :key="index" >
                            <el-image class="IMG" :src="item" :preview-src-list="exceptionFilesView" > </el-image>
                        </div>
                    </div>
                    <el-upload drag
                        :action="issueGoodsIMGupLoadFilesURL" multiple :auto-upload="false" 
                        list-type="picture-card" :file-list="exceptionFiles" :headers="headers"
                        :on-change="handleChangeException"
                        :on-remove="handleRemoveException"
                        :on-preview="handlePreviewException"
                        :accept="acceptImageTypes"
                        >
                        <i class="el-icon-plus"></i>
                    </el-upload>
                </div>
            </div>
            <!-- 移库只上传作业图片 -->
            <div v-else>
                <div class="finish_upload">
                    <!-- <div class="finish_text">上传车辆/货物图片</div> -->
                    <div class="finish_text">
                        <span> 上传移库作业照片 </span>
                    </div>
                    <div class="finish_IMG">
                        <div v-for="(item,index) in inventoryMoveFilesView" :key="index" >
                            <el-image class="IMG" :src="item" :preview-src-list="inventoryMoveFilesView" > </el-image>
                        </div>
                    </div>
                    <el-upload drag
                        :action="issueGoodsIMGupLoadFilesURL" multiple :auto-upload="false" 
                        list-type="picture-card" :file-list="inventoryMoveFiles"  :headers="headers"
                        :on-change="handleChangeInventoryMoveFiles"
                        :on-remove="handleRemoveInventoryMoveFiles"
                        :on-preview="handlePreviewInventoryMoveFiles"
                        :accept="acceptImageTypes"
                        >
                        <i class="el-icon-plus"></i>
                    </el-upload>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button size="mini" @click="viewCompleteworkClose">取 消</el-button>
                <el-button size="mini" type="primary" @click="saveTemporaryIssueGoodsRows">暂 存</el-button>
                <el-button size="mini" type="primary" @click="saveIssueGoodsRows">保 存</el-button>
            </span>
        </el-dialog>
        <!-- 预览图片 -->
        <el-dialog :visible.sync="dialogVisiblePreview">
            <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>
    </div>
</template>
<script>
import clean from 'lodash-clean';
import basicData from '@/config/basicData.js'
import AEObasicData from '@/config/AEObasicData.js'
import { findNameByCode, findCodeByName } from '@/utils/dict.js'
import { webapp_ws_ajax_run, webapp_urlprotocol_startup, urlAddRandomNo,webapp_ws_autoupdate, webapp_ws_ajax_together } from "../../utils/reports/grwebapp";
    export default {
        name: '',
        props: {
            viewCompleteworkVisible: {
                type: Boolean,
                default: false,
            },
            // 作业row信息
            completeworkRow: {
                type: Object,
                default: () => {}
            }
        },
        data() {
            return {
                loading:false,
                unitList:AEObasicData.CUS_UNIT, // 计量单位
                finishIssueGoodsList:{}, // 确认完成作业行信息列表
                finishIssueGoodsListVisit:{}, // 原数据不可修改，做参照
                signWorkTable:[], // 工作量表格

                acceptFiles:[], // 受理单图片上传
                openingBoxBrforeFiles:[], // 开箱前图片上传
                inHomeWorkFiles:[], // 作业中图片上传
                endHomeWorkFiles:[], // 作业结束图片上传
                exceptionFiles:[], // 异常图片上传
                inventoryMoveFiles:[], // 移库作业上传

                acceptFilesView:[], // 受理单图片查看
                openingBoxBrforeFilesView:[], // 开箱前图片查看
                inHomeWorkFilesView:[], // 作业中图片查看
                endHomeWorkFilesView:[], // 作业结束图片查看
                exceptionFilesView:[], // 异常图片查看
                inventoryMoveFilesView:[], // 移库作业图片查看

                dialogImageUrl:'', // 图片预览url
                dialogVisiblePreview:false, // 图片预览弹窗
                // 理货员列表
                storekeeperList:[],
                // 确认作业完成时上传受理单、车辆货物、异常等图片
                issueGoodsIMGupLoadFilesURL:'wms/taskOp/upLoadFiles',
                acceptImageTypes: '.jpg,.jpeg,.png,.gif,.bmp,.webp',// 限制上传图片类型
                placeList:[], // 库区列表
                locationList:[], // 库位列表
                signWorkGoodsNameList:[], // 货物名称列表
                // 工作量单位、类型、叉车司机列表
                signWorkUnitList:basicData.signWorkUnitList,
                signWorkTypeList:basicData.signWorkTypeList,
                signWorkDriverList:basicData.signWorkDriverList,
                headers:{ // 导入文件token
                    'token': localStorage.getItem('token')
                },
                // 确认作业完成
                finishIssueGoodsFormRules:{
                    storekeeper:[
                        { required: true, message: '请选择理货员', trigger: 'change' },
                    ],
                    completeDate:[
                        { required: true, message: '请选择日期', trigger: 'change' },
                    ]
                },
                pickerOptions:{
                    disabledDate(time) {
                        const today = new Date();
                        // 今日零点时间戳
                        const todayZero = new Date(today.getFullYear(), today.getMonth(), today.getDate()).getTime();
                        // 往前推2天零点
                        const twoDayAgo = todayZero - 2 * 24 * 60 * 60 * 1000;
                        const curTime = time.getTime();
                        // 小于两天前 或者 大于今天 都禁用
                        return curTime < twoDayAgo || curTime > todayZero;
                    },
                },
            }
        },
        watch: {
            viewCompleteworkVisible:{
                async handler(val) {
                    if(val){
                        this.loading = false
                        // 设置加载状态
                        // 如果行状态是未完成，则编辑
                        this.finishIssueGoodsList = JSON.parse(JSON.stringify(this.completeworkRow)) 
                        // 出入库日期默认是今天
                        this.finishIssueGoodsList.completeDate = new Date().toISOString().split('T')[0]
                        // 存一个不能修改的原数据
                        this.finishIssueGoodsListVisit = JSON.parse(JSON.stringify(this.completeworkRow)) 
                        if(this.completeworkRow.rowStatus !== '完成' ){
                            // 获取库位库区信息,入库获取库区库位，出库不获取
                            if(this.completeworkRow.taskType === '入库作业'){
                                await this.getStore(this.completeworkRow.ckName)
                            }
                        }
                        // 根据仓库名称修改理货员列表
                        if(this.completeworkRow.ckName === '纽约路仓库'){
                            this.storekeeperList = basicData.storekeeperList
                            this.signWorkDriverList = basicData.signWorkDriverList

                        }else if(this.completeworkRow.ckName === '七星河路仓库'){
                            this.storekeeperList = basicData.storekeeperListOut
                            this.signWorkDriverList = basicData.signWorkDriverListOut
                        }
                        // 获取工作量信息
                        this.$api.wmsGetWorkLoadsByOpId(this.completeworkRow.id).then(res => {
                            this.signWorkTable = res
                        })
                        // 获取上传图片
                        this.$api.wmsGetTaskFiles(this.completeworkRow.id).then(res => {
                            this.acceptFilesView = res.acceptFiles.map(item => item.filePath)
                            this.openingBoxBrforeFilesView = res.preUnboxingPic.map(item => item.filePath)
                            this.inHomeWorkFilesView = res.workingPic.map(item => item.filePath)
                            this.endHomeWorkFilesView = res.endWorkPic.map(item => item.filePath)
                            this.exceptionFilesView = res.exceptionFiles.map(item => item.filePath)
                            this.inventoryMoveFilesView = res.moveFiles.map(item => item.filePath)
                            
                        })
                         if (this.completeworkRow.goodsName.includes(',')) {
                            this.signWorkGoodsNameList  = this.completeworkRow.goodsName.split(',').map(item => ({
                                value: item.trim(),
                                label: item.trim()
                            }));
                         }else{
                            this.signWorkGoodsNameList = [{
                                value: this.completeworkRow.goodsName,
                                label: this.completeworkRow.goodsName
                            }];
                        }
                        this.loading = true
                        await this.$nextTick()
                    }
                },
                deep: true,
                immediate: true
            },
        },
        methods: {
            // 关闭弹窗
            viewCompleteworkClose(){
                this.$emit('viewCompleteworkClose',this.completeworkRow.interId)
                this.finishIssueGoodsList = {}
                this.finishIssueGoodsListVisit = {}
                // this.completeworkRow = {}
                this.signWorkTable = []
                this.acceptFiles = [] // 受理单图片
                this.openingBoxBrforeFiles = [] // 开箱前图片
                this.inHomeWorkFiles = [] // 作业中图片
                this.endHomeWorkFiles = [] // 作业中图片
                this.exceptionFiles = [] // 异常图片

                this.acceptFilesView = []
                this.openingBoxBrforeFilesView = []
                this.inHomeWorkFilesView = []
                this.endHomeWorkFilesView = []
                this.exceptionFilesView = []
                this.inventoryMoveFilesView = []
            },

            // 获取库区列表
            getStore(ckName){
                this.$api.getStore( ckName ).then(res =>{
                    this.placeList = res
                })
            },
            // 修改行作业信息的库区，批量填充
            placeRowEnter(value,row,rowIndex){
                if(value === ''){
                    this.locationList = []
                }else{
                    const placeItem  = value.split('-')
                    // this.getLocation(placeItem[1])

                    // 如果是第一行则下面的行全部赋值
                    if( Number(rowIndex) === 0){
                        this.finishIssueGoodsList.childList.forEach((item, i) => {
                            // 使用 $set 确保响应式更新
                            this.$set(this.finishIssueGoodsList.childList[i], 'place', placeItem[0]);
                        });
                    }else{
                        this.finishIssueGoodsList.childList.forEach((item, i) => {
                            // 使用 $set 确保响应式更新
                            if(rowIndex === i){
                                this.$set(this.finishIssueGoodsList.childList[i], 'place', placeItem[0]);
                            }
                        });
                    }
                }
                if(rowIndex === 0){
                    this.finishIssueGoodsList.childList.forEach((item, i) => {
                        // 使用 $set 确保响应式更新
                        this.$set(this.finishIssueGoodsList.childList[i], 'location', '');
                    });
                }else{
                    this.finishIssueGoodsList.childList.forEach((item, i) => {
                        // 使用 $set 确保响应式更新
                        if(rowIndex === i){
                            this.$set(this.finishIssueGoodsList.childList[i], 'location', '');
                        }
                    });
                }
                
            },
            // 批量库位
            locationRowEnter(value,row,rowIndex){
                if(value !== ''){
                    // 如果是第一行则下面的行全部赋值
                    if(rowIndex === 0){
                        this.finishIssueGoodsList.childList.forEach((item, i) => {
                            // 使用 $set 确保响应式更新
                            this.$set(this.finishIssueGoodsList.childList[i], 'location', value);
                            
                        });
                    }
                }
            },
            // 获取焦点时触发 ,查询库位
            locationRowFocus(row,rowIndex){
                if(row.place){
                    const targetPlace = this.placeList.find(item => item.name === row.place)
                    this.getLocation(targetPlace.id)
                }
            },
            // 查询库位列表
            getLocation(id){
                this.$api.getLocation( id ).then(res =>{
                    this.locationList = res
                })
            },
            // 拆分货物信息，将件数清零
            async splitFinishIssueGoods(row,index){
                const $table = this.$refs.finishIssueGoodsTable;
                if ($table) {
                    // qty1:0,qty2: 0,netWeight: 0,decAmount:0
                    const newData = { ...this.finishIssueGoodsListVisit.childList[index] } ;
                    // 删除id属性
                    delete newData.id
                    // if (!this.finishIssueGoodsList.childList) {
                    //     this.$set(this.finishIssueGoodsList, 'childList', [])
                    // }
                    this.finishIssueGoodsList.childList.push(newData)
                    this.finishIssueGoodsListVisit.childList.push(JSON.parse(JSON.stringify(newData)))
                    // 等待 DOM 更新
                    await this.$nextTick();
                }
            },
            // 输入件数1顺带修改件数2，净重、申报金额、法一、法二、申报数量
            finishIssueGoodsRowQty1Blur(row,index){
                row.qty2 = this.calculateAllPlanFields(this.finishIssueGoodsList.childList[index].planQty2,this.finishIssueGoodsList.childList[index].planQty1,row.qty1)
                row.netWeight = this.calculateAllPlanFields(this.finishIssueGoodsList.childList[index].planNetWeight,this.finishIssueGoodsList.childList[index].planQty1,row.qty1)
                row.decNum = this.calculateAllPlanFields(this.finishIssueGoodsListVisit.childList[index].decNum,this.finishIssueGoodsListVisit.childList[index].planQty1,row.qty1)
                row.firstNum = this.calculateAllPlanFields(this.finishIssueGoodsListVisit.childList[index].firstNum,this.finishIssueGoodsListVisit.childList[index].planQty1,row.qty1)
                row.secondNum = this.calculateAllPlanFields(this.finishIssueGoodsListVisit.childList[index].secondNum,this.finishIssueGoodsListVisit.childList[index].planQty1,row.qty1)
                row.decAmount = this.calculateAllPlanFields(this.finishIssueGoodsList.childList[index].planDecAmount,this.finishIssueGoodsList.childList[index].planQty1,row.qty1)
            },
            // 净重、申报数量、金额、件数2，法一，法二 计算
            calculateAllPlanFields(number,qty1Value,planQty1Value){
                if(!number){
                    return null
                }else{
                    const value = Number(number) || 0;
                    const qty1 = Number(qty1Value); // 选中数据的件数1
                    const planQty1 = Number(planQty1Value); // 填写出库的件数1
                    // 计算并保留指定位小数
                    const result = (value / qty1) * planQty1;
                    
                    const factor = Math.pow(10, 4);  // 10000
                    // Number.EPSILON  大约是 2.220446049250313e-16 这是 JavaScript 中最小的正数用于解决浮点数计算中的精度问题
                    return Math.round((result + Number.EPSILON) * factor) / factor;  // 加一个极小的数，避免浮点数误差;乘以10^4，将小数变为整数,四舍五入
                }
            },
            // 删除行信息
            delIssueGoodsRow(row,index){
                this.$confirm('确定要删除此行明细吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.finishIssueGoodsList.childList.splice(index, 1);
                    this.finishIssueGoodsListVisit.childList.splice(index, 1);
                }).catch(() => {
                    // 用户取消删除，不做任何操作
                });
            },
            // 新增叉车司机工作量行
            async addSignWorkRowEvent(){
                const $table = this.$refs.signWorkTable;
                if ($table) {
                    const newData  = {
                            taskId: this.completeworkRow.id ,
                            goodsName: this.signWorkGoodsNameList[0].value,
                            driver: '',
                            tons: 0,
                            remark:'',
                            workType:'',
                            workUnit:'',
                        };
                        this.signWorkTable.push(newData)
                        // 等待 DOM 更新
                        await this.$nextTick();
                }
            },
            // 删除叉车司机工作量行
            delSignWork(row, index){
                this.signWorkTable.splice(index, 1);
            },
            // 文件状态改变 受理单
            handleChangeAccept(file, fileList){
                this.acceptFiles = fileList
            },
            // 文件删除
            handleRemoveAccept(file, fileList){
                this.acceptFiles = fileList
            },
            // 文件预览
            handlePreviewAccept(file){
                this.dialogImageUrl = file.url;
                this.dialogVisiblePreview = true;
            },
            // 文件状态改变 开箱前
            handleChangeOpeningBoxBrfore(file, fileList){
                this.openingBoxBrforeFiles = fileList
            },
            // 文件删除
            handleRemoveOpeningBoxBrfore(file, fileList){
                this.openingBoxBrforeFiles = fileList
            },
            // 文件预览
            handlePreviewOpeningBoxBrfore(file){
                this.dialogImageUrl = file.url;
                this.dialogVisiblePreview = true;
            },
            // 文件状态改变 作业中
            handleChangeInHomeWork(file, fileList){
                this.inHomeWorkFiles = fileList
            },
            handleRemoveInHomeWork(file, fileList){
                this.inHomeWorkFiles = fileList
            },
            // 文件预览
            handlePreviewInHomeWork(file){
                this.dialogImageUrl = file.url;
                this.dialogVisiblePreview = true;
            },
            // 文件状态改变 作结束
            handleChangeEndHomeWork(file, fileList){
                this.endHomeWorkFiles = fileList
            },
            handleRemoveEndHomeWork(file, fileList){
                this.endHomeWorkFiles = fileList
            },
            // 文件预览
            handlePreviewEndHomeWork(file){
                this.dialogImageUrl = file.url;
                this.dialogVisiblePreview = true;
            },
            // 文件状态改变 异常
            handleChangeException(file, fileList){
                this.exceptionFiles = fileList
            },
            // 文件删除
            handleRemoveException(file, fileList){
                this.exceptionFiles = fileList
            },
            // 文件预览
            handlePreviewException(file){
                this.dialogImageUrl = file.url;
                this.dialogVisiblePreview = true;
            },
            // 文件状态改变  移库
            handleChangeInventoryMoveFiles(file, fileList){
                this.inventoryMoveFiles = fileList
            },
            handleRemoveInventoryMoveFiles(file, fileList){
                this.inventoryMoveFiles = fileList
            },
            handlePreviewInventoryMoveFiles(file){
                this.dialogImageUrl = file.url;
                this.dialogVisiblePreview = true;
            },
            // 工作量批量赋值
            changeDriver(value,row,rowIndex){
                if(value === ''){
                    row.driver = ''
                }else{
                    // 如果是第一行则下面的行全部赋值
                    if(rowIndex === 0){
                        this.signWorkTable.forEach((item, i) => {
                            // 使用 $set 确保响应式更新
                            this.$set(this.signWorkTable[i], 'driver', value);
                        });
                    }
                }
            },
            signWorkTableRowTonsInput(value,row ,rowIndex){
                if(rowIndex === 0){
                    this.signWorkTable.forEach((item, i) => {
                        // 使用 $set 确保响应式更新
                        this.$set(this.signWorkTable[i], 'tons', value);
                    });
                }
            },
            changeWorkUnit(value,row,rowIndex){
                if(value === ''){
                    row.workUnit = ''
                }else{
                    // 如果是第一行则下面的行全部赋值
                    if(rowIndex === 0){
                        this.signWorkTable.forEach((item, i) => {
                            // 使用 $set 确保响应式更新
                            this.$set(this.signWorkTable[i], 'workUnit', value);
                        });
                    }
                }
            },
            changeWorkType(value,row,rowIndex){
                if(value === ''){
                    row.workType = ''
                }else{
                    // 如果是第一行则下面的行全部赋值
                    if(rowIndex === 0){
                        this.signWorkTable.forEach((item, i) => {
                            // 使用 $set 确保响应式更新
                            this.$set(this.signWorkTable[i], 'workType', value);
                        });
                    }
                }
            },
            // 项号批量
            batchItemNo(row ,value ,rowIndex){
                if(value === ''){
                    row.itemNo = ''
                }else{
                    // 如果是第一行则下面的行全部赋值
                    if(rowIndex === 0){
                        this.finishIssueGoodsList.childList.forEach((item, i) => {
                            // 使用 $set 确保响应式更新
                            this.$set(this.finishIssueGoodsList.childList[i], 'itemNo', value);
                        });
                    }
                }
            },
            // 暂存图片和工作量
            async saveTemporaryIssueGoodsRows(){
                // 保存工作量
                try {
                    if(this.signWorkTable.length ){
                        await this.$api.wmsSignWork(this.signWorkTable)
                    }
                    // 保存图片
                    await this.saveIssueGoodsIMG()
                    this.$message({
                        type: 'success',
                        message: '暂存成功'
                    });
                    await this.viewCompleteworkClose()
                    // 关闭弹窗
                }catch (error) {
                    this.$message.error('暂存失败，请重试');
                }
                
            },
            // 构造提交参数：剔除表格行主键rowKey，避免临时行主键提交到后端
            buildSubmitParams(list){
                return clean({
                    ...list,
                    childList: (list.childList || []).map(({ rowKey, ...row }) => row)
                })
            },
            // 未完成状态保存
            async UnfinishedStatusSave(){
                    try {
                    // 校验必填项
                    this.$refs.finishIssueGoodsForm.validate(async (valid) => {
                        if (valid) {
                            // 校验货物信息
                            const finishIssueGoodsErrors = []
                            this.finishIssueGoodsList.childList.forEach((rowGoods, indexGoods) => {
                                // 验证 库区库位
                                if (rowGoods.location === '' || rowGoods.place === '') {
                                    finishIssueGoodsErrors.push(`第${indexGoods + 1}行：库区库位不能为空`)
                                }
                                if ((rowGoods.itemNo === '' || !rowGoods.itemNo ) &&  this.finishIssueGoodsList.isBonded === '保税' && this.finishIssueGoodsList.taskType === '入库作业' ) {
                                    finishIssueGoodsErrors.push(`第${indexGoods + 1}行：项号不能为空`)
                                }
                                // 验证实际件数1
                                if (this.isEmptyOrZero(rowGoods.qty1)) {
                                    finishIssueGoodsErrors.push(`第${indexGoods + 1}行：实际件数1不能为空且不能为0`)
                                }
                                // 验证实际件数2
                                if (!!this.finishIssueGoodsList.childList[indexGoods]?.qty2  && this.isEmptyOrZero(rowGoods.qty2)) {
                                    finishIssueGoodsErrors.push(`第${indexGoods + 1}行：实际件数2不能为空且不能为0`)
                                }
                                // 验证实际净重
                                if (!!this.finishIssueGoodsList.childList[indexGoods]?.netWeight  && this.isEmptyOrZero(rowGoods.netWeight)) {
                                    finishIssueGoodsErrors.push(`第${indexGoods + 1}行：实际净重不能为空且不能为0`)
                                }
                                // 验证实际申报金额
                                if (!!this.finishIssueGoodsList.childList[indexGoods]?.decAmount  && this.isEmptyOrZero(rowGoods.decAmount)) {
                                    finishIssueGoodsErrors.push(`第${indexGoods + 1}行：实际申报金额不能为空且不能为0`)
                                }
                            })
                            if(finishIssueGoodsErrors.length){
                                this.$message.error('请填写完整货物信息');
                                return 
                            }
                            // 校验叉车司机工作量
                            if(this.signWorkTable.length){
                                // 判断是否填写叉车司机和工作量
                                const signWorkErrors = []
                                this.signWorkTable.forEach((rowSignWork, indexSignWork) => {
                                    // 验证 叉车司机
                                    if (rowSignWork.driver === '') {
                                        signWorkErrors.push(`第${indexSignWork + 1}行：叉车司机不能为空`)
                                    }
                                    // 验证 工作量
                                    if (!!rowSignWork?.tons  && this.isEmptyOrZero(rowSignWork.tons)) {
                                        signWorkErrors.push(`第${indexSignWork + 1}行：工作量不能为空且不能为0`)
                                    }
                                })
                                if(signWorkErrors.length){
                                    this.$message.error('请填写叉车司机和工作量')
                                    return 
                                }
                            }
                            // 判断是否有受理单,如果没有不允许保存
                            // 新增条件：ckName是七星河路仓库 并且 place是二号库或者五号库不上传
                            const IMGIcon = this.finishIssueGoodsList.ckName === '七星河路仓库' 
                                ? this.finishIssueGoodsList.childList.some(item =>  item.place === '2号库' || item.place === '5号库' ) : false; 
                            if(!this.acceptFiles.length && !this.acceptFilesView.length && this.finishIssueGoodsList.ownerName !== '浙商中拓集团股份有限公司' 
                                && !IMGIcon ){
                                this.$message.error('请上传受理单图片');
                                return
                            }
                            if(!this.openingBoxBrforeFiles.length && !this.openingBoxBrforeFilesView.length && this.finishIssueGoodsList.ownerName !== '浙商中拓集团股份有限公司'
                                && !IMGIcon ){
                                this.$message.error( this.completeworkRow.taskType === '出库作业' ? '请上传空箱图片' : '请上传开箱前图片');
                                return
                            }
                            if(!this.inHomeWorkFiles.length && !this.inHomeWorkFilesView.length && this.finishIssueGoodsList.ownerName !== '浙商中拓集团股份有限公司'
                                && !IMGIcon ){
                                this.$message.error('请上传作业中图片');
                                return
                            }
                            if(!this.endHomeWorkFiles.length && !this.endHomeWorkFilesView.length && this.finishIssueGoodsList.ownerName !== '浙商中拓集团股份有限公司'
                                && !IMGIcon ){
                                this.$message.error('请上传作业结束图片');
                                return
                            }
                            // 保存工作量
                            if(this.signWorkTable.length ){
                                await this.$api.wmsSignWork(this.signWorkTable)
                            }
                            // 保存图片
                            await this.saveIssueGoodsIMG()
                            // 完成任务
                            // 入库
                            if(this.finishIssueGoodsList.taskType === '入库作业'){
                                const params = this.buildSubmitParams(this.finishIssueGoodsList)
                                await this.$api.wmsinBoundTask( params ).then(res =>{
                                    this.$message({
                                        type: 'success',
                                        message: '作业任务已成功'
                                    });
                                    // 关闭刷新页面
                                    this.viewCompleteworkClose()
                                })
                            }else{
                                // 保存表头 出库
                                const params = this.buildSubmitParams(this.finishIssueGoodsList)
                                await this.$api.insertOrUpdateTaskOp(params); 
                                await this.$api.wmsfinishCkOp(this.finishIssueGoodsList.id).then( async res =>{
                                    this.$message({
                                        type: 'success',
                                        message: '作业任务已成功'
                                    });
                                    // 打印出门证
                                    await this.reportOut()
                                    // 关闭刷新页面
                                    await this.viewCompleteworkClose()
                                })
                            }
                            
                        }
                    })
                } catch (error) {
                    this.$message.error('保存部分数据失败，请重试');
                }
            },
            // 打印出门证
            reportOut(){
                try {
                    let LHhasSulfur = false; // 硫磺
                    let ZJhasSulfur = false; // 纸浆
                    this.finishIssueGoodsList.childList.forEach(item => {
                        const name = item.goodsName || '';
                        const ownerName = item.ownerName || '';

                        if (name.includes('硫磺')) LHhasSulfur = true;
                        // if (name.includes('纸浆')) ZJhasSulfur = true;
                        if (ownerName.includes('建发')) ZJhasSulfur = true;

                    });
                    let tableTask = [];
                    // 如果是硫磺则合并
                    if(LHhasSulfur){
                        // 货物名称和规格型号一样合并
                        const groupMap = new Map();
                        this.finishIssueGoodsList.childList.forEach(item => {
                            // 分组唯一标识：goodsName + spec + qty1Unit 拼接
                            const groupKey = `${item.goodsName}_${item.spec}_${item.qty1Unit}`;
                            if (groupMap.has(groupKey)) {
                                // 已有分组，累加数量、净重
                                const target = groupMap.get(groupKey);
                                target.qty1 += item.qty1;
                                target.netWeight += item.netWeight;
                            } else {
                                // 新建分组对象
                                groupMap.set(groupKey, {
                                    goodsName: item.goodsName,
                                    qty1Unit: item.qty1Unit,
                                    qty1: item.qty1,
                                    netWeight: item.netWeight
                                });
                            }
                        })
                        tableTask = Array.from(groupMap.values()).map(item => ({
                            ...item,
                            note: this.finishIssueGoodsList.opNote,
                            createUser:this.finishIssueGoodsList.createMan,
                            truckNo:this.finishIssueGoodsList.truckNo,
                            // completeTime: item.completeTime ? item.completeTime.split('T')[0] + '  ' + item.completeTime.split('T')[1] : '',
                            qty1UnitName: this.findNameByCode(item.qty1Unit, AEObasicData.CUS_UNIT)
                        }))
                    }else{
                        tableTask = this.finishIssueGoodsList.childList.map(item => ({
                            ...item,
                            note: this.finishIssueGoodsList.opNote,
                            createUser:this.finishIssueGoodsList.createMan,
                            truckNo:this.finishIssueGoodsList.truckNo,
                            // completeTime: item.completeTime ? item.completeTime.split('T')[0] + '  ' + item.completeTime.split('T')[1] : '',
                            qty1UnitName: this.findNameByCode(item.qty1Unit, AEObasicData.CUS_UNIT),
                        }));
                    }
                    const master = {
                        ZJShow:!ZJhasSulfur,
                    }
                    const params = { 
                        master: master, 
                        table: tableTask 
                    };
                    var args = {
                        report: urlAddRandomNo("/grf/出门证.grf"),
                        data: params,
                        type: "preview",
                    };
                    webapp_ws_ajax_run(args);
                } catch (error) {
                    console.error('打印处理失败:', error);
                }
            },
            // 通用查找方法
            findNameByCode(code, list) {
                return findNameByCode(code, list)
            },
            // 完成状态下保存
            async finishedStatusSave(){
                try {
                    // 校验叉车司机工作量
                    if(this.signWorkTable.length){
                        // 判断是否填写叉车司机和工作量
                        const signWorkErrors = []
                        this.signWorkTable.forEach((rowSignWork, indexSignWork) => {
                            // 验证 叉车司机
                            if (rowSignWork.driver === '') {
                                signWorkErrors.push(`第${indexSignWork + 1}行：叉车司机不能为空`)
                            }
                            // 验证 工作量
                            if (!!rowSignWork?.tons  && this.isEmptyOrZero(rowSignWork.tons)) {
                                signWorkErrors.push(`第${indexSignWork + 1}行：工作量不能为空且不能为0`)
                            }
                        })
                        if(signWorkErrors.length){
                            this.$message.error('请填写叉车司机和工作量')
                            return 
                        }
                    }
                    // 保存工作量
                    if(this.signWorkTable.length){
                        // 删除id
                        this.signWorkTable.forEach(item => delete item.id)
                        await this.$api.wmsSignWork(this.signWorkTable)
                    }
                    // 保存图片
                    await this.saveIssueGoodsIMG() 
                    // 刷新页面
                    // 查询工作量
                    this.$api.wmsGetWorkLoadsByOpId(this.completeworkRow.id).then(res => {
                        this.signWorkTable = res
                    })
                    // 查询图片
                    this.$api.wmsGetTaskFiles(this.completeworkRow.id).then(res => {
                        this.acceptFilesView = res.acceptFiles.map(item => item.filePath)
                        this.openingBoxBrforeFilesView = res.openingBoxBrforeFiles.map(item => item.filePath)
                        this.inHomeWorkFilesView = res.openingBoxBrforeFiles.map(item => item.filePath)
                        this.endHomeWorkFilesView = res.openingBoxBrforeFiles.map(item => item.filePath)
                        this.exceptionFilesView = res.exceptionFiles.map(item => item.filePath)
                    })
                    // 清空上传图片列表
                    this.acceptFiles = [] // 受理单图片
                    this.openingBoxBrforeFiles = [] // 开箱前图片
                    this.inHomeWorkFiles = [] // 作业中图片
                    this.endHomeWorkFiles = [] // 作业结束图片
                    this.exceptionFiles = [] // 异常图片         
                } catch (error) {
                    this.$message.error('保存部分数据失败，请重试');
                }
            },
            // 移库完成保存
            wmsFinishYkOp(){
                this.$refs.finishIssueGoodsForm.validate(async (valid) => {
                    if (valid) {
                        // 判断是否上传图片
                        if(!this.inventoryMoveFiles.length && !this.inventoryMoveFilesView.length){
                            this.$message.error('请上传移库作业图片');
                            return
                        }
                        this.$api.wmsFinishYkOp(this.completeworkRow.id).then( async res => {
                            // 保存工作量
                            if(this.signWorkTable.length){
                                // 删除id
                                this.signWorkTable.forEach(item => delete item.id)
                                await this.$api.wmsSignWork(this.signWorkTable)
                            }
                            // 保存图片
                            await this.saveIssueGoodsIMG() 
                            // 关闭
                            this.viewCompleteworkClose()
                        })
                    }
                })
                
            },
            // 保存
            async saveIssueGoodsRows(){
                try {
                    const text = this.completeworkRow.taskType === '入库作业' ? '入库作业完成请检查是否填写项号！' : ''
                    this.$alert('是否确定保存？' + text , '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(async () => {
                        if(this.completeworkRow.rowStatus !== '完成' ){
                            // 如果是还出入库则调用
                            if( this.completeworkRow.taskType === '入库作业' || this.completeworkRow.taskType === '出库作业' ){
                                await this.UnfinishedStatusSave()
                            }else if(this.completeworkRow.taskType === '移库作业') {
                                this.wmsFinishYkOp()
                            }
                        }else{
                            await this.finishedStatusSave()
                        }
                    }).catch(() => {});
                    
                }catch (error) {

                }           
            },
            isEmptyOrZero(value) {
                // 检查是否为空或为0
                return value === '' || value === null || value === undefined || 
                    value === 0 || value === '0' || value === 0.0 || 
                    (typeof value === 'string' && value.trim() === '')
            },
            // 保存图片
            async saveIssueGoodsIMG(){
                // 保存
                if(this.acceptFiles.length){
                    const formDataAccept = new FormData();
                    this.acceptFiles.forEach(item => {
                        formDataAccept.append('files', item.raw);
                    });
                    await this.$api.wmsupLoadFilesIMG('受理单信息', this.completeworkRow.id, formDataAccept )
                }
                if(this.openingBoxBrforeFiles.length){
                    const formDataOpeningBoxBrfore = new FormData();
                    this.openingBoxBrforeFiles.forEach(item => {
                        formDataOpeningBoxBrfore.append('files', item.raw);
                    });
                    await this.$api.wmsupLoadFilesIMG('开箱前', this.completeworkRow.id, formDataOpeningBoxBrfore )
                }
                if(this.inHomeWorkFiles.length){
                    const formDataInHomeWork = new FormData();
                    this.inHomeWorkFiles.forEach(item => {
                        formDataInHomeWork.append('files', item.raw);
                    });
                    await this.$api.wmsupLoadFilesIMG('作业中', this.completeworkRow.id, formDataInHomeWork )
                }
                if(this.endHomeWorkFiles.length){
                    const formDataEndHomeWork = new FormData();
                    this.endHomeWorkFiles.forEach(item => {
                        formDataEndHomeWork.append('files', item.raw);
                    });
                    await this.$api.wmsupLoadFilesIMG('作业结束', this.completeworkRow.id, formDataEndHomeWork )
                }
                if(this.inventoryMoveFiles.length){
                    const inventoryMove = new FormData();
                    this.inventoryMoveFiles.forEach(item => {
                        inventoryMove.append('files', item.raw);
                    });
                    await this.$api.wmsupLoadFilesIMG('移库作业', this.completeworkRow.id, inventoryMove )
                }
                if(this.exceptionFiles.length){
                    const formDataException = new FormData();
                    this.exceptionFiles.forEach(item => {
                        formDataException.append('files', item.raw);
                    });
                    await this.$api.wmsupLoadFilesIMG('异常信息', this.completeworkRow.id, formDataException )
                }
            },
        }
    }
</script>
<style lang="less" scoped>
.width_100{
    width: 100%;
}
.finish_upload{
    margin: 5px 0px;
    font-size: 14px;
    font-weight: bold;
    width:50%

}
.finish_IMG{
    display: flex;
}
.finish_IMG .IMG{
    width: 100px; 
    height: 100px;
    margin-left: 10px;
}
.finish_text{
    margin-bottom: 5px;
}
.IssueGoodsExitRow_flex{
    display: flex;
}
.IssueGoodsExitRow{
    display: flex;
    justify-content:space-between;
    flex-direction: column;
}
.IssueGoodsTipText{
    width: 100%;
    font-weight: bold;
    margin: 0px 5px;
    text-align: right;
    font-size: 10px;
}
::v-deep .finishIssueGood_dialog .el-dialog .el-dialog__body{
     height: 500px !important;
     overflow-y: auto !important;
}
::v-deep .el-upload--picture-card{
    width:100px !important;
    height:100px !important;
    line-height: 100px !important;
}
::v-deep .el-upload-list--picture-card .el-upload-list__item{
    width:100px !important;
    height:100px !important;
    line-height: 100px !important;
}
::v-deep .el-upload-dragger{
    width:100px !important;
    height:100px !important;
    line-height: 100px !important;
}
</style>
